module.exports = __webpack_public_path__ + "img/chauffe-eau-central.34e5befe.svg";